import { useQueries } from '@tanstack/react-query'

import { fetchOneByCode } from 'services/redemption-codes'

const KEY = 'redemption-codes'

export function useRedemptionCodes(codes: string[]) {
  return useQueries({
    queries: codes.map((code) => ({
      queryKey: [KEY, code],
      queryFn: () => fetchOneByCode(code),
    })),
  })
}
